import { render } from "./electronicChannelDetail.vue?vue&type=template&id=512f1730&scoped=true"
import script from "./electronicChannelDetail.vue?vue&type=script&lang=js"
export * from "./electronicChannelDetail.vue?vue&type=script&lang=js"

import "./electronicChannelDetail.vue?vue&type=style&index=0&id=512f1730&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "/home/pages/train-manage/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-512f1730"]])

export default __exports__